<template>
  <div>
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:w-full tw:my-5 tw:gap-x-4">
      <div class="tw:w-full tw:md:w-[calc(100%-320px)] tw:lg:w-[60%] tw:flex tw:flex-col tw:justify-between">
        <SectionHeader
          :logo="RateConnectLogo"
          productName="Rate Connect"
          :title="$t('tbs_home_rc_promo')"
          :subtext="$t('rate_connect_promo_subtext')"
        />
        <div class="tw:flex tw:mb-5" v-if="isRateConnectEligible">
          <RateConnectConnection />
        </div>
        <ul class="tw:gap-y-2 tw:flex tw:flex-col tw:mb-4">
          <li v-for="point in points" :key="point.id" class="tw:flex tw:items-center tw:gap-x-1">
            <img :src="CheckIcon" :alt="point.text" class="tw:h-6 tw:w-6" />
            <p>{{ $t(point.text) }}</p>
          </li>
        </ul>
        <p class="tw:text-xs tw:text-gray-500">
          {{ $t('rate_connect_disclaimer') }}
        </p>
      </div>
      <div class="tw:md:flex tw:items-center tw:lg:items-end tw:hidden tw:justify-end tw:w-[320px] tw:flex-shrink-0">
        <RateConnectBanner />
      </div>
    </div>
    <div class="tw:flex tw:md:flex-row tw:flex-col tw:w-full tw:justify-end tw:gap-x-2.5">
      <GhostButton
        class="icon-btn tw:flex tw:gap-x-2 tw:items-center tw:justify-center tw:mb-4 tw:md:mb-0"
        @click="openVideo"
      >
        <PlayIcon class="tw:fill-gray-800" />
        {{ $t('promo_video_cta') }}
      </GhostButton>
      <MainButton @click="launchCampaign">{{ $t(buttonLabel) }}</MainButton>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import RateConnectConnection from '@/components/homePage/rateConnect/RateConnectConnection.vue'
import SectionHeader from '@/components/homePage/SectionHeader.vue'

import appAnalytics from '@/utils/tracking'

import GhostButton from '@/components/base/buttons/GhostButton.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import PlayIcon from '@/components/icons/PlayIcon.svg?component'
import RateConnectBanner from '@/components/homePage/rateConnect/RateConnectBanner.vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'

const RateConnectLogo = new URL('/src/assets/img/landing/landing_rate_connect.svg', import.meta.url)

const CheckIcon = new URL(`../../../assets/img/homepage/CheckIcon.png`, import.meta.url)

const store = useStore()
const router = useRouter()
const emit = defineEmits(['openVideo'])
const openVideo = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_RATE_CONNECT_LEARN_MORE_BTN_CLICKED, {
    accommodationId: selectedAccommodationId.value,
  })
  emit('openVideo')
}
const props = defineProps({
  isRateConnectEligible: Boolean,
})
const { hasAdminOrSupport } = useSessionValues()
const points = [
  { id: 0, text: 'tbs_home_rc_feature_1' },
  { id: 1, text: 'tbs_home_rc_feature_2' },
  { id: 3, text: 'tbs_home_rc_feature_3' },
  { id: 4, text: 'tbs_home_rc_feature_4' },
]

const buttonLabel = computed(() => {
  if (!hasAdminOrSupport.value) return 'rc_admin_log_in_cta'
  else if (props.isRateConnectEligible) return 'rate_connect_cta'
  else return 'tbs_mp_learn_more_cta'
})
const launchCampaign = () => {
  if (hasAdminOrSupport.value) {
    appAnalytics.track(appAnalytics.events.HOMEPAGE_RATE_CONNECT_LAUNCH_CAMPAIGN, {
      accommodationId: selectedAccommodationId.value,
    })
    router.push({ name: 'rate-connect-no-campaign' })
  } else {
    store.dispatch('session/logout', '/rate-connect/no-campaign?loginAsAdmin=true')
  }
}
</script>
<style scoped>
.icon-btn:hover svg {
  fill: white;
}
</style>
